import { useState, createContext } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import {
  getOrdersUserService,
  editOrderUserService,
  deleteOrderUserService,
} from "../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";

export const orderUserContext = createContext({
  orders: [],
  setOrders: () => {},
  order: {},
  setOrder: () => {},
  id: "",
  setId: () => {},
  filter: "",
  setFilter: () => {},
  sort: "",
  setSort: () => {},
  start: "",
  setStart: () => {},
  end: "",
  setEnd: () => {},
  status: "",
  setStatus: () => {},
  invoiceStatus: "",
  setInvoiceStatus: () => {},
  productType: "",
  setProductType: () => {},
  pageCount: null,
  setPageCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  itemsCount: null,
  setItemsCount: () => {},
  isShowModal: null,
  setIsShowModal: () => {},
  handleShowModal: () => {},
  handleHideModal: () => {},
  handleGetOrders: () => {},
  handleEditOrder: () => {},
  handleDeleteOrder: () => {},
});

const OrderUserContext = ({ children }) => {
  const dispatch = useDispatch();

  const { user, product, invoice } = useParams();

  const [orders, setOrders] = useState([]);
  const [order, setOrder] = useState({});
  const [id, setId] = useState("");
  const [filter, setFilter] = useState("");
  const [sort, setSort] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [status, setStatus] = useState("");
  const [invoiceStatus, setInvoiceStatus] = useState("");
  const [productType, setProductType] = useState("");
  const [pageCount, setPageCount] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsCount, setItemsCount] = useState(50);

  // Get Orders
  const handleGetOrders = async (event) => {
    event?.preventDefault();

    const objData = {
      ...(start && { start }),
      ...(end && { end }),
      ...(user && { user }),
      ...(product && { product }),
      ...(invoice && { invoice }),
      filter,
      pageNumber,
      sort,
      itemsCount,
      status,
      invoiceStatus,
      productType,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getOrdersUserService(objData);
      if (status === 200) {
        setOrders(data.result?.orders);
        setPageCount(data?.result?.allPagesCount);
      }
    } catch ({ response }) {
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Edit Order
  const handleEditOrder = async (details) => {
    const objData = {
      id: order._id,
      status: details.status,
      renewalDate: details.renewalDate,
      details,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await editOrderUserService(objData);
      if (status === 200) {
        setOrder({});
        toastSuccessMessage(data.resultMessage);
        handleGetOrders();
      }
    } catch ({ response }) {
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
      dispatch(setLoadingFalseAction());
    }
  };

  // Delete Order
  const handleDeleteOrder = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await deleteOrderUserService(id);
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        handleGetOrders();
      }
    } catch ({ response }) {
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <orderUserContext.Provider
      value={{
        orders,
        setOrders,
        order,
        setOrder,
        id,
        setId,
        filter,
        setFilter,
        sort,
        setSort,
        start,
        setStart,
        end,
        setEnd,
        status,
        setStatus,
        invoiceStatus,
        setInvoiceStatus,
        productType,
        setProductType,
        pageCount,
        setPageCount,
        pageNumber,
        setPageNumber,
        itemsCount,
        setItemsCount,
        handleGetOrders,
        handleEditOrder,
        handleDeleteOrder,
      }}
    >
      {children}
    </orderUserContext.Provider>
  );
};

export default OrderUserContext;
